/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import React, {ForwardedRef, forwardRef, useContext, useImperativeHandle, useState} from 'react';
import {ErrorType, validateEmail} from '@dvrd/dvr-controls';
import {AppContext} from "../../misc/appContext";
import TestMail from "./testMail";
import {ActivateHandle} from "../../../util/interfaces";

interface Props {
    onSubmit: (email: string) => void;
    closeOnSubmit?: boolean;
}

export type TestMailRef = ActivateHandle<string | null | undefined> & {setLoading: (value: boolean) => void; onClose: VoidFunction};

function TestMailController(props: Props, ref: ForwardedRef<TestMailRef>) {
    const context = useContext(AppContext);
    const {onSubmit, closeOnSubmit} = props;
    const [active, setActive] = useState(false);
    const [email, setEmail] = useState('');
    const [error, setError] = useState<ErrorType>(null);
    const [loading, setLoading] = useState(false);

    function onActivate(email?: string) {
        setActive(true);
        setEmail(email ?? context.accountContext.account?.email ?? '');
    }

    function onClose() {
        setActive(false);
        setEmail('');
        setLoading(false);
        setError(null);
    }

    function onChangeEmail(email: string) {
        setEmail(email);
    }

    function _onSubmit() {
        if (!validateEmail(email)) {
            setError('Vul een geldig e-maildres in');
            return;
        }
        onSubmit(email);
        if (closeOnSubmit) onClose();
    }

    function onResetError() {
        setError(null);
    }

    useImperativeHandle(ref, () => ({activate: onActivate, setLoading, onClose}));

    return (
        <TestMail onChange={onChangeEmail} onSubmit={_onSubmit} onClose={onClose} onResetError={onResetError}
                  error={error} active={active} email={email} loading={loading}/>
    );
}

export default forwardRef<TestMailRef, Props>(TestMailController);